import Axios from 'axios';
import qs from 'qs';


/*******************************wxH5支付 */

export const getToPayInfo = (params) => {
  // phone
  console.log("params:", params)
  params.action = "getGameInfo";
  params.v = window.h5Version;
  return Axios.post(window.XGurl, qs.stringify(params))
}

// 下单参数
export const webUnifiedOrder = (params) => {
  // phone
  console.log("params:", params)
  params.action = "webUnifiedOrder";
  params.v = window.h5Version;
  return Axios.post(window.XGurl, qs.stringify(params))
}




// 获取订单号
export const appletPayBillno = (params) => {
  // phone
  console.log("params:", params, window.ReqUrl)
  return Axios.post(window.ReqUrl, qs.stringify(params))
}

// log打点
export const reportLog = (appid, openid, key) => {
  // phone
  const project = 'xunguang-log'
    const host = 'cn-shanghai.log.aliyuncs.com'
    const url = `https://${project}.${host}/logstores/event_log/track?APIVersion=0.6.0&a=${appid}&o=${openid}&k=${key}`

  return Axios.get(url)
}



// WEBPACK FOOTER //
// ./src/api/request.js